const config = {
  baseURL: process.env.VUE_APP_baseURL,
  exelLocation: process.env.VUE_APP_exelLocation,
  timeout: 60000,
};

export default config;
